import { NumericFormat } from "react-number-format";
import { InputV3, type InputV3Props } from "components/common/input/InputV3";
import type { FormattedNumberInputProps } from "./FormattedNumberInput.types";

export const FormattedNumberInput = ({
  thousandSeparator = true,
  allowNegative = false,
  ...props
}: FormattedNumberInputProps) => (
  <NumericFormat<InputV3Props>
    {...props}
    customInput={InputV3}
    type="text"
    thousandSeparator={thousandSeparator}
    allowNegative={allowNegative}
  />
);
